import { render, staticRenderFns } from "./FlexTableContainer.vue?vue&type=template&id=38e76da1"
import script from "./FlexTableContainer.vue?vue&type=script&lang=js"
export * from "./FlexTableContainer.vue?vue&type=script&lang=js"
import style0 from "./FlexTableContainer.vue?vue&type=style&index=0&id=38e76da1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports